import { Controller } from 'react-hook-form';
import { Checkbox } from '@ui/src';
import { RiskScoreCalculationType } from '../../hoc/types';
import { FormBlockTypes } from './types';

import cn from './form.module.css';

const FormBlock = ({
  control,
  calculateBy,
  radioName,
  disabled,
  children,
  minimumRiskScore,
  volumeRiskBlock,
}: FormBlockTypes) => (
  <div className={cn.formBlock}>
    <div className={cn.formBlockTitle}>Calculate by:</div>
    <div className={cn.formBlockRow}>
      <Controller
        control={control}
        name={radioName}
        render={({ field: { onChange } }) => (
          <Checkbox
            name={`checkbox-weight-${radioName}`}
            title="Weight"
            value={RiskScoreCalculationType.WEIGHT}
            onChange={() => onChange(RiskScoreCalculationType.WEIGHT)}
            type="radio"
            checked={
              calculateBy && !disabled
                ? Boolean(calculateBy === RiskScoreCalculationType.WEIGHT)
                : false
            }
            disabled={disabled}
          />
        )}
      />
      <div className={cn.formBlockInputs}>{children}</div>
    </div>
    <div className={cn.formBlockRow}>
      <Controller
        control={control}
        name={radioName}
        defaultValue={RiskScoreCalculationType.WEIGHT}
        render={({ field: { onChange } }) => (
          <Checkbox
            name={`checkbox-max-${radioName}`}
            title="Maximum risk score"
            onChange={() => onChange(RiskScoreCalculationType.MAX)}
            value={RiskScoreCalculationType.MAX}
            type="radio"
            checked={
              calculateBy && !disabled
                ? Boolean(calculateBy === RiskScoreCalculationType.MAX)
                : false
            }
            disabled={disabled}
          />
        )}
      />
    </div>
    {!volumeRiskBlock && (
      <div className={cn.formBlockRow}>
        <Controller
          control={control}
          name={radioName}
          defaultValue={RiskScoreCalculationType.WEIGHT}
          render={({ field: { onChange } }) => (
            <Checkbox
              name={`checkbox-average-${radioName}`}
              title={
                minimumRiskScore ? 'Minimum risk score' : 'Average risk score'
              }
              value={
                minimumRiskScore
                  ? RiskScoreCalculationType.MIN
                  : RiskScoreCalculationType.AVG
              }
              onChange={() =>
                onChange(
                  minimumRiskScore
                    ? RiskScoreCalculationType.MIN
                    : RiskScoreCalculationType.AVG,
                )
              }
              type="radio"
              checked={
                calculateBy && !disabled
                  ? Boolean(
                      calculateBy ===
                      (minimumRiskScore
                        ? RiskScoreCalculationType.MIN
                        : RiskScoreCalculationType.AVG),
                    )
                  : false
              }
              disabled={disabled}
            />
          )}
        />
      </div>
    )}
  </div>
);

export default FormBlock;
